import * as types from "../types";

const initialState = {
  loading: false,
  satellitePatch: null,
  requestPatch: null,
  error: null,
};

export default function satellitePatchReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.FETCH_SATELLITE_PATCH_REQUEST:
      return {
        ...state,
        loading: true,
        requestPatch: action.payload.requestPatch,
      };

    case types.FETCH_SATELLITE_PATCH_SUCCESS:
      return {
        ...state,
        loading: false,
        satellitePatch: action.payload.satellitePatch,
      };

    case types.FETCH_SATELLITE_PATCH_FAILURE:
      return {
        ...state,
        loading: false,
        satellitePatch: null,
        requestPatch: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}